import { FurnitureType } from '@app/types/furniture.types';

export enum ContactFormControls {
  Name = 'name',
  Contact = 'contact',
  FurnitureType = 'furnitureType',
  Location = 'location',
  Description = 'description'
}

export interface ContactFormData {
  name?: string;
  contact?: string;
  furnitureType?: FurnitureType;
  location?: string;
  message?: string;
  files?: ContactFormFile[];
}

export interface ContactFormFile {
  name: string;
  data: string;
}
